/* eslint-disable import/no-anonymous-default-export */
export default {
	json: `
    [ 
        { 
        "title" : "MR"
        "name" : "Joe Bloggs", 
        "referenceNumber": "JWTR67",
        "flightDetails" : { 
            "origin" : "MAN", 
            "destination" : "DUB",
            "carrierCode" : "EI", 
            "flightNumber" : "205", 
            "departureDate" : "2022-01-01" 
        }, 
        "assistance" : ["WCHS"], 
        "equipmentInformation" : { 
            "make" : "Activ", 
            "model" : "A1 ECI", 
            "weight" : 11, 
            "battery" : "Lithium",
            "dimensions" : { 
            "height" : 250, 
            "width" : 100 
            } 
        },
        "serviceAnimal" : false 
        } 
    ] 
    `,
    jsonDuplicate: `
    [ 
        { 
        "title" : "MR",
        "name" : "Joe Bloggs", 
        "referenceNumber": "JWTR67",
        "flightDetails" : { 
            "origin" : "MAN", 
            "destination" : "DUB" 
            "carrierCode" : "EI", 
            "flightNumber" : "205", 
            "departureDate" : "2022-01-01" 
        }, 
        "assistance" : ["WCHR, DPNA"], 
        "equipmentInformation" : { 
            "make" : "Activ", 
            "model" : "A1 ECI", 
            "weight" : 11, 
            "battery" : "Lithium",
            "dimensions" : { 
            "height" : 250, 
            "width" : 100 
            } 
        },
        "serviceAnimal" : false 
        } 
    ] 
    `
    ,response1: `
    [ 
        "EI205-2022-01-01-joe-bloggs", 
        "EI105-2022-01-02-qH3ffg3y" 
    ] 
    `
    ,response2: `
    [
        {
            "ok": true,
            "id": "EI206-2022-12-05_fhi",
            "rev": "1-0853710474f5265caab992d2b4e26a44"
        }
    ]
    `
    ,
    responseDuplicate: `
    [
        {
            "ok": true,
            "id": "EI205-2022-01-01_joe-bloggs",
            "rev": "1-4a951777fe686b00d6f3312f3499594a"
        }
    ]
    `
    ,
    responseDuplicate2: `
    [
        {
            "ok": true,
            "id": "EI205-2022-01-01_joe-bloggs",
            "rev": "2-b00095faa63cdba503d0ee05a1c0f16d"
        }
    ]
    `
    ,
    response3: `
    [ 
        "EI205-2022-01-01-joe-bloggs", 
        "EI105-2022-01-02-qH3ffg3y"
    ] 
    `
    ,exampleBookingDatabase: `
        { 
            "_id" : "EI205-2022-01-01-joe-bloggs", 
            "name" : "Joe Bloggs", 
            "referenceNumber": "JWTR617",
            "flightDetails" : { 
            "origin" : "MAN", 
            "destination" : "DUB" 
            "carrierCode" : "EI", 
            "flightNumber" : "205", 
            "departureDate" : "2022-01-01" 
            }, 
            "assistance" : ["WCHS"], 
            "equipmentInformation" : { 
            "make" : "Activ", 
            "model" : "A1 ECI", 
            "weight" : 11, 
            "battery" : "Lithium" 
            "dimensions" : { 
                "height" : 250, 
                "width" : 100 
            } 
            } 
            "serviceAnimal" : false
        } 
    `
    ,multipleBookingsResponse: `
    { 
        "data" : [ 
            { 
            "_id" : "EI205-2022-01-01-john-smith",
            "referenceNumber": "JWTR617",
            "name" : "John Smith", 
            "flightDetails" : { 
                "origin" : "MAN", 
                "destination" : "DUB" 
                "carrierCode" : "EI", 
                "flightNumber" : "205", 
                "departureDate" : "2023-01-10" 
            }, 
            "assistance" : ["WCHS"], 
            "equipmentInformation" : { 
                "make" : "Activ", 
                "model" : "A1 ECI", 
                "weight" : 11, 
                "battery" : "Lithium" 
                "dimensions" : { 
                "height" : 250, 
                "width" : 100 
                } 
            } 
            "serviceAnimal" : false  
            }, 
        
        // ... more matching bookings 
        
           ], 
        } 
    `
    ,multipleBookingCountResponse: `
    { 
        "data" : [ 
        // matching bookings ... 
        ], 
        "counts" : { 
        "2023-01-01" : 459, 
        "2023-01-02" : 560, 
        "2023-01-03" : 342, 
        // ... 
        } 
    } 
    `
    ,acknowledgementResponse: `
    {
    "EK161-2022-12-05_plxhiqlbcppfx": "error: Revision of booking does not match",
    "EK161-2022-12-05_pllxhiqlbcppfx": "error: Booking was not found",
    "EK162-2022-12-06_sdkfljglbswrfx": "ok"
    }
    `


    ,acknowledgementBody: `
    [
    {
        "id": "EK161-2022-12-05_plxhiqlbcppfx",
        "rev": "6-71efb632837f0b4eafff473f32775b2f"
    },
    {
        "id": "EK161-2022-12-05_psdfsdfofx",
        "rev": "4-71sld4475f7557wl548sf35g9s2b2f"
    },
    {
        "id": "EK162-2022-12-06_sdkfljglbswrfx",
        "rev": "3-71sldkf28238497wl548sf35g9s2b2f"
    }
    ]
    `
    ,patchResponse: `
    { 
        "_id" : "EI205-2022-01-01-joe-bloggs",  
        "name" : "Joe Bloggs", 
        "referenceNumber": "JWTR617",
        "flightDetails" : { 
        "origin" : "MAN", 
        "destination" : "DUB",
        "carrierCode" : "EI", 
        "flightNumber" : "205", 
        "departureDate" : "2022-01-01" 
        }, 
        "assistance" : ["WCHS"], 
        "equipmentInformation" : { 
        "make" : "Activ", 
        "model" : "A1 ECI", 
        "weight" : 11, 
        "battery" : "Lithium",
        "dimensions" : { 
            "height" : 250, 
            "width" : 100 
        } 
        } 
        "serviceAnimal" : true 
    } 
    `
    ,patchResponse2: `
    { 
        "_id" : "EI105-2022-01-02-joe-bloggs",  
        "name" : "Joe Bloggs", 
        "referenceNumber": "JWTR617",
        "flightDetails" : { 
        "origin" : "DUB", 
        "destination" : "JFK" 
        "carrierCode" : "EI", 
        "flightNumber" : "105", 
        "departureDate" : "2022-01-02" 
        }, 
        "assistance" : ["WCHS"], 
        "equipmentInformation" : { 
        "make" : "Activ", 
        "model" : "A1 ECI", 
        "weight" : 11, 
        "battery" : "Lithium",
            "dimensions" : { 
                "height" : 250, 
                "width" : 100 
            } 
        },
        "serviceAnimal" : false 
    } 
    `
    ,deleteBooking: `
    { 
        Response: '201'
    }
    `
    ,jwt: `
    {
        "token": 
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoJIjp0cnVlfSwiYWlyc8"
    }
    `
    ,pollingNewBookings: `
    {
        "data": [
          {
            "id": "EK161-2022-12-05_plxhiqlbcppfx",
            "rev": "6-71efb632837f0b4eafff473f32775b2f"
          }
          
          // ... more matching bookings

          
        ],
        "total_rows": 50,
        "offset": 0
      }
    `
};